exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-list {\n  min-height: 200px;  \n}\n\n.loading-list {\n  padding: 10px 10px;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/users/userlist/user-list.component.css
// module id = 1939
// module chunks = 0